import axios from "axios";
const { API_BACKEND_HOST } = process.env;

const api = axios.create({
  baseURL: `${API_BACKEND_HOST}`,
});

interface ICreateParams {
  name: string;
  businessUnitId: string;
}

interface IUpdateParams {
  id: string;
  name: string;
  businessUnitId: string;
}

export const createCommitteePackage = async (params: ICreateParams) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.post(
    `${API_BACKEND_HOST}${languageId}/v1/CommitteePackage`,
    {
      ...params,
    },
  );

  return data;
};

export const updateCommitteePackage = async (params: IUpdateParams) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.put(
    `${API_BACKEND_HOST}${languageId}/v1/CommitteePackage/${params.id}`,
    {
      ...params,
    },
  );

  return data;
};

interface IGetCommitteePackageResponse {
  name: string;
  businessUnitId: string;
  businessUnitName: string;
  active: boolean;
  admin: boolean;
  committees: {
    id: string;
    name: string;
  }[];
  groups: {
    id: string;
    name: string;
    groupAdminLevel: number;
  }[]
}

export interface ICommitteeOption {
  name: string;
  id: string;
  admin: boolean;
}

interface IGetAllCommittee {
  committeePackages: ICommitteeOption[];
}

export const getCommitteePackageById = async (id: string) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get<IGetCommitteePackageResponse>(
    `${API_BACKEND_HOST}${languageId}/v1/CommitteePackage/${id}`,
  );

  return data;
};

export const getAll = async () => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get<IGetAllCommittee>(
    `${API_BACKEND_HOST}${languageId}/v1/CommitteePackage`,
  );

  return data;
};

export const addCommitteeToPackage = async (committeePackageId: string, committeeId: string) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.patch<IGetCommitteePackageResponse>(
    `${API_BACKEND_HOST}${languageId}/v1/CommitteePackage/id:Guid/committee/id:Guid`,
    {
      
    }, 
    {
      params: {
        'committeePackageId': committeePackageId,
        'CommitteeId': committeeId
      }
    }
  );

  return data;
};

export const removeCommitteeToPackage = async (committeePackageId: string, committeeId: string) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.delete<IGetCommitteePackageResponse>(
    `${API_BACKEND_HOST}${languageId}/v1/CommitteePackage/id:Guid/committee/id:Guid`,
    {
      params: {
        'committeePackageId': committeePackageId,
        'CommitteeId': committeeId
      }
    }
  );

  return data;
};

export const toggleActive = async (id: string, active: boolean) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.patch(
    `${API_BACKEND_HOST}${languageId}/v1/CommitteePackage/${id}`,
    {
      active
    },
  );

  return data;
};
